import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { shortFormattedTime } from 'shared/utils/formattedTime';

const propTypes = {
  formattedTime: PropTypes.func,
  finishAction: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

const defaultProps = {
  formattedTime: shortFormattedTime,
  finishAction: noop,
  onChange: noop,
  className: '',
};

class Timer extends Component {
  state = {
    time: 0,
  };

  componentDidMount() {
    this.timerId = setInterval(() => {
      this.setState((prevState) => ({
        time: prevState.time + 1,
      }), () => this.props.onChange(this.state.time));
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
    this.props.finishAction(this.state.time);
  }

  render() {
    const { formattedTime } = this.props;
    const { time } = this.state;

    return (
      <span className={ this.props.className }>
        { formattedTime(time) }
      </span>
    );
  }
}

Timer.propTypes = propTypes;
Timer.defaultProps = defaultProps;

export default Timer;
